import { Alert, Spin } from "@arco-design/web-react";

import type { ItineraryCustomizationInfoRow } from "../types";

type Props = {
  title?: string;
  rows: ItineraryCustomizationInfoRow[];
  loading: boolean;
  error: boolean;
};

/** 展示行程关联的定制项目与需求版本，只读内容沿用定制详情表的字段口径。 */
export function ItineraryCustomizationPanel({ title, rows, loading, error }: Props) {
  if (loading) {
    return (
      <div className="itinerary-customization-state" role="status" aria-live="polite">
        <Spin size={24} />
        <span>正在加载定制信息…</span>
      </div>
    );
  }

  if (error || !title) {
    return (
      <div className="itinerary-customization-state">
        <Alert
          type={error ? "error" : "info"}
          showIcon
          content={error ? "定制信息加载失败，请稍后重试。" : "当前行程暂无关联的定制版本。"}
        />
      </div>
    );
  }

  const orderVersionKey = rows.find((row) => row.key === "identity.orderVersionKey")?.value?.trim();
  const operatingCompany = rows.find((row) => row.key === "form.operatingCompany")?.value?.trim();

  return (
    <div className="itinerary-customization-info" aria-label="定制信息详情">
      {orderVersionKey ? (
        <div className="itinerary-customization-info-version" aria-label="定制版本">
          <span className="itinerary-customization-info-version-dot" aria-hidden="true" />
          <strong>{orderVersionKey}</strong>
          {operatingCompany ? <span className="itinerary-customization-info-version-label">【{operatingCompany}】</span> : null}
        </div>
      ) : null}
      <div className="itinerary-customization-info-title" aria-label="定制标题" title={title}>
        {title}
      </div>
      <table className="itinerary-customization-info-table">
        <tbody>
          {rows.map((row) => (
            <tr key={row.key ?? row.label}>
              <th scope="row">{row.label}</th>
              <td className={row.changed ? "is-changed" : undefined}>{row.value || "--"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
